import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, CheckCircle } from 'lucide-react';
const names = ['María G.', 'Laura S.', 'Carolina P.', 'Daniela R.', 'Valentina M.', 'Sofía L.', 'Camila T.', 'Florencia B.', 'Agustina V.', 'Romina D.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const triggerPopup = () => {
      // Generate random data
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 minutes
      setCurrentPurchase({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next popup (between 8 and 12 seconds)
      const nextInterval = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(triggerPopup, nextInterval);
    };
    // Initial trigger after 3 seconds
    const initialTimer = setTimeout(triggerPopup, 3000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-242">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start space-x-4" data-id="element-243">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-244">
            <ShoppingCart className="w-6 h-6 text-green-600" data-id="element-245" />
          </div>
          <div data-id="element-246">
            <div className="flex items-center space-x-1" data-id="element-247">
              <p className="text-sm font-bold text-gray-900" data-id="element-248">
                {currentPurchase.name}
              </p>
              <span className="text-xs text-gray-500" data-id="element-249">
                de {currentPurchase.city}, Argentina
              </span>
            </div>
            <p className="text-sm text-gray-700 mt-0.5 leading-tight" data-id="element-250">
              acaba de comprar el{' '}
              <span className="font-bold text-red-600" data-id="element-251">MegaPack</span>
            </p>
            <div className="flex items-center space-x-1 mt-1.5" data-id="element-252">
              <CheckCircle className="w-3 h-3 text-green-500" data-id="element-253" />
              <p className="text-xs text-gray-400 font-medium" data-id="element-254">
                Hace {currentPurchase.time}{' '}
                {currentPurchase.time === 1 ? 'minuto' : 'minutos'}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}